import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import cogoToast from "cogo-toast";
import { Consumer } from "../../context";
import Request from "../../core/httpClient";

const request = new Request();
const BlackoutDates = ({ idEspacio, context }) => {
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState('');
    const [motivo, setMotivo] = useState('');
    const [fechasBloqueadas, setFechasBloqueadas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [loadRemoving, setLoadRemoving] = useState(false);

    useEffect(() => {
        getFechasBloqueadas();
    }, [idEspacio]);

    async function addDate(e) {
        e.preventDefault();
        setLoading(true);



        const user = await context.loadUser();


        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: fecha,
                motivo,
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 1
            };



            await saveData(data);
        } else {

            console.log("context.loadUser() devolvió null o undefined");
        }
    }


    async function removeDate(item) {
        setLoadRemoving(item.id);
        const user = await context.loadUser();

        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: item.fecha,
                motivo: '',
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 2
            };
            await saveData(data);
        }
    }

    async function saveData(data) {
        try {

            const response = await request.post("/commonArea/bloquear/fecha", data);

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.updated) {
                    if (data.tipo === 1) {
                        cogoToast.success("Fecha bloqueada agregada correctamente.", { position: "bottom-right" });
                        setFecha('');
                        setMotivo('');
                    } else {
                        cogoToast.success("Fecha bloqueada eliminada correctamente.", { position: "bottom-right" });
                    }
                    await getFechasBloqueadas();
                }

                if (response.existe) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                    setFecha('');
                    setMotivo('');
                }
            }

            setLoading(false);
            setLoadRemoving(false);
        } catch (error) {
            console.log(error);
        }
    }

    async function getFechasBloqueadas() {
        try {
            setLoadingData(true);
            const response = await request.post("/commonArea/get/fechasBloqueadas", { id_espacio: idEspacio });

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.empty) {
                    setFechasBloqueadas([]);
                }

                if (response.fechas_bloqueadas) {
                    const arrayBloqueos = response.fechas_bloqueadas.map(row => ({
                        fecha: row.fecha_bloqueada,
                        motivo: row.motivo,
                        id: row.id
                    }));
                    setFechasBloqueadas(arrayBloqueos);
                }
            }

            setLoadingData(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="full row align-center">
            <div className="column full">
                <div className="white-space-4"></div>
                <div className="column">
                    <p>
                        <b>Políticas de uso:</b>
                    </p>
                    <div className="white-space-8"></div>
                    <div className="align-center row full">
                        <div className="column full">
                            <textarea
                                name="descripcion"
                                className="textarea input input-modals"
                                cols="50"
                                rows="5"
                                autoComplete="off"
                                value={descripcion}
                                onChange={(event) => {
                                    setDescripcion(event.target.value)

                                }}
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="white-space-8"></div>
                <div className="column">
                    <p>
                        <b>Defina qué fechas quiere bloquear:</b>
                    </p>
                    <div className="white-space-8"></div>
                    <div className="align-center row full">
                        <div className="row full">
                            <form className="width-45" onSubmit={addDate}>
                                <div className="column">
                                    <p>Fecha a bloquear:</p>
                                    <input className="input" type="date" name="fecha" required onChange={(e) => setFecha(e.target.value)} />
                                </div>
                                <div className="white-space-8"></div>
                                <div className="column">
                                    <p>Motivo: </p>
                                    <input type="text" className="input" name="motivo" required onChange={(e) => setMotivo(e.target.value)} />
                                </div>
                                <div className="white-space-8"></div>
                                <div>
                                    <button className="btn btn-primary color-white full" type="submit" onClick={addDate}>
                                        {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Agregara'}
                                    </button>
                                </div>
                            </form>
                            <div className="fechas-bloqueadas full">
                                <div className="card-table card-owners column" id="card-owners">
                                    <div className="table-responsiv column">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="text-left">Fecha bloqueada</th>
                                                    <th className="text-left">Motivo</th>
                                                    <th className="text-center">Quitar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loadingData ? <tr>
                                                    <td colSpan="3">
                                                        <div className="white-space-8"></div>
                                                        <div className="justify-center">
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                        </div>
                                                        <div className="white-space-8"></div>
                                                    </td>
                                                </tr> :
                                                    fechasBloqueadas.length !== 0 ? fechasBloqueadas.map((item, i) => {
                                                        return <tr key={i}>
                                                            <td>{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                                            <td>{item.motivo}</td>
                                                            <td className="text-center">{loadRemoving === item.id ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-times-circle color-red cursor-pointer space-4" onClick={removeDate.bind(this, item)}></i>}</td>
                                                        </tr>
                                                    }) :
                                                        <tr>
                                                            <td colSpan="3">
                                                                <div className="justify-center">
                                                                    <h4>No se encontraron resultados.</h4>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Consumer(BlackoutDates);